import React from "react";

const FacebookIcon = () => {
  return (
    <svg
      width="10"
      height="20"
      viewBox="0 0 10 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.34 19.353V10.55h2.85l.427-3.432H6.34v-2.19c0-.994.267-1.67 1.64-1.67h1.753V.187A22.595 22.595 0 0 0 7.18.053c-2.526 0-4.256 1.6-4.256 4.535v2.53H.067v3.43h2.857v8.805"
        fill="#FFF"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default FacebookIcon;
